import { useTruncate } from '@nesso/ui/hooks/use-truncate';
import { cn } from '@nesso/ui/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nesso/ui/primitives/tooltip';

import { useLongPressTooltip } from '@/shared/lib/use-long-press-tooltip';

type TruncatedTextWithTooltipProps = {
    text: string;
    className?: string;
    tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
    tooltipAlign?: 'start' | 'center' | 'end';
};

export function TruncatedTextWithTooltip({
    text,
    className,
    tooltipSide = 'bottom',
    tooltipAlign = 'start',
}: TruncatedTextWithTooltipProps) {
    const { ref: textRef, isTruncated } = useTruncate<HTMLSpanElement>({ dependency: text });
    const { open, onOpenChange, longPressHandlers } = useLongPressTooltip({ enabled: isTruncated });

    const content = (
        <span
            ref={textRef}
            className={cn('block w-full truncate', className)}
            {...longPressHandlers}
        >
            {text}
        </span>
    );

    if (!isTruncated) return content;

    return (
        <Tooltip delayDuration={300} open={open} onOpenChange={onOpenChange}>
            <TooltipTrigger asChild>{content}</TooltipTrigger>
            <TooltipContent
                side={tooltipSide}
                align={tooltipAlign}
                className="max-w-xs overflow-hidden text-ellipsis whitespace-nowrap"
            >
                <span className="block text-sm">{text}</span>
            </TooltipContent>
        </Tooltip>
    );
}
